import React, { useRef, useState, useEffect } from 'react';

const InputAssinatura = (props) => {
	const canvasRef = useRef(null);
	const [isAssinando, setIsAssinando] = useState(false);

	useEffect(() => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');

		ctx.lineWidth = 2;
		ctx.lineCap = 'round';
		ctx.strokeStyle = 'black';
	}, []);

	const iniciarAssinatura = (x, y) => {
		const ctx = canvasRef.current.getContext('2d');

		ctx.beginPath();
		ctx.moveTo(x, y);

		setIsAssinando(true);
	};

	const assinatura = (x, y) => {
		if (!isAssinando) return;

		const ctx = canvasRef.current.getContext('2d');

		ctx.lineTo(x, y);
		ctx.stroke();
	};

	const finalizarAssinatura = () => {
		const ctx = canvasRef.current.getContext('2d');

		ctx.closePath();

		setIsAssinando(false);
	};

	// =========================
	// TOUCH EVENTS
	// =========================

	const handleTouchStart = (e) => {
		e.preventDefault();

		const rect = canvasRef.current.getBoundingClientRect();

		const x = e.touches[0].clientX - rect.left;
		const y = e.touches[0].clientY - rect.top;

		iniciarAssinatura(x, y);
	};

	const handleTouchMove = (e) => {
		e.preventDefault();

		const rect = canvasRef.current.getBoundingClientRect();

		const x = e.touches[0].clientX - rect.left;
		const y = e.touches[0].clientY - rect.top;

		assinatura(x, y);
	};

	// =========================
	// ACTIONS
	// =========================

	const limparAssinatura = () => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');

		ctx.clearRect(0, 0, canvas.width, canvas.height);

		props.onChange(null);
	};

	const salvarAssinatura = () => {
		const canvas = canvasRef.current;

		const dataURL = canvas.toDataURL();

		props.onChange(dataURL);
	};

	const handleImageUpload = (event) => {
		const file = event.target.files[0];

		if (file) {
			const reader = new FileReader();

			reader.onload = (e) => {
				props.onChange(e.target.result);
			};

			reader.readAsDataURL(file);
		}
	};

	// =========================
	// RESPONSIVO
	// =========================

	let width =
		window.innerWidth < 500
			? window.innerWidth - 10
			: window.innerWidth - 200;

	let height = (width * 100) / 500;

	if (height > 300) {
		width = (width * 200) / height;
		height = 200;
	}

	return (
		<div
			className='form-group'
			style={{
				display: 'flex',
				flexDirection: 'column',
				width: width
			}}
		>
			{props.label && <label>{props.label}</label>}

			<canvas
				ref={canvasRef}
				width={width}
				height={height}
				style={{
					touchAction: 'none',
					border: '2px solid #000',
					backgroundColor: '#ffffff',
					display: props.value ? 'none' : null
				}}
				onMouseDown={(e) =>
					iniciarAssinatura(
						e.nativeEvent.offsetX,
						e.nativeEvent.offsetY
					)
				}
				onMouseMove={(e) => {
					assinatura(
						e.nativeEvent.offsetX,
						e.nativeEvent.offsetY
					);
				}}
				onMouseUp={finalizarAssinatura}
				onMouseLeave={finalizarAssinatura}
				onTouchStart={handleTouchStart}
				onTouchMove={handleTouchMove}
				onTouchEnd={finalizarAssinatura}
			/>

			{props.value && (
				<img
					style={{
						border: '2px solid #000',
						backgroundColor: '#ffffff',
						width: width,
						height: height
					}}
					src={props.value}
				/>
			)}

			{!props.readOnly && (
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						paddingTop: 2
					}}
				>
					{!props.semGaleria && (
						<>
							<input
								id={props.idUploadAssinatura || 'uploadAssinatura'}
								type='file'
								accept='image/*'
								onChange={handleImageUpload}
								style={{ display: 'none' }}
							/>

							<label
								htmlFor={props.idUploadAssinatura || 'uploadAssinatura'}
								className='btn btn-block btn-warning btn-xs'
								style={{
									marginTop: 0,
									marginLeft: 0,
									marginBottom: 0,
									marginRight: 1,
									cursor: 'pointer'
								}}
							>
								Selecionar Imagem
							</label>
						</>
					)}

					<button
						type='button'
						className='btn btn-block btn-success btn-xs'
						onClick={salvarAssinatura}
						style={{
							marginTop: 0,
							marginLeft: 0,
							marginBottom: 0,
							marginRight: 1
						}}
						disabled={props.value}
					>
						Salvar
					</button>

					<button
						type='button'
						className='btn btn-block btn-danger btn-xs'
						onClick={limparAssinatura}
						style={{
							marginTop: 0,
							marginLeft: 1,
							marginBottom: 0,
							marginRight: 0
						}}
					>
						Limpar
					</button>
				</div>
			)}
		</div>
	);
};

export default InputAssinatura;